import React from 'react';
import jsonLogic from 'json-logic-js';

import {getVariables} from '../../lib/json-logic-utils';
import reducers from './reducers';
import NoDataWidget from '../NoDataWidget';
import BarChart from '../BarChart';
import LargeWidgetValue from '../LargeWidgetValue';
import Number from '../Number';
import WidgetHeader from "../WidgetHeader";

function BarChartWidget({widget, rows, questions, options, id, formulaDeletedQuestions}) {
  const buckets = rows.reduce((buckets, row) => {
    const variables = getVariables(row.answers, questions);

    if (widget.filter && !jsonLogic.apply(widget.filter, variables)) {
      // Filter excludes this value, so don't modify it.
      return buckets;
    }

    const value = jsonLogic.apply(widget.map, variables);
    const group = row.answers.filter(answer => answer.questionId === widget.groupByQuestion)[0];

    if (!group) {
      // Grouping question was not answered.
      return buckets;
    }

    const key = questions[group.questionId].type === 'DATETIME'
    ? new Date(parseInt(group.value.split(',')[0], 10)).toLocaleString()
    : group.value

    if (!buckets[key]) {
      buckets[key] = [];
    }

    buckets[key].push(value);
    return buckets;
  }, {});
  
  const numBuckets = Object.keys(buckets).length;

  if (numBuckets < 1) {
    return <NoDataWidget id={id} title={widget.title} options={options} question={widget} formulaDeletedQuestions={formulaDeletedQuestions}/>;
  }

  const reducer = new (reducers[widget.aggregation])(rows);
  const data = Object.keys(buckets).map((group, i) => {
    const bucket = buckets[group];

    return {
      index: i + 1,
      name: group,
      value: bucket.reduce(reducer.reduce.bind(reducer), reducer.initialValue())
    };
  });

  if (questions[widget.groupByQuestion].type === 'DATETIME') {
    data.sort((a, b) => new Date(a.name).getTime() - new Date(b.name).getTime());
  }

  if (numBuckets === 1) {
    return (
        <React.Fragment>
          <WidgetHeader title={widget.title} options={options} id={id} formulaDeletedQuestions={formulaDeletedQuestions}/>
          <LargeWidgetValue>
            <Number>{data[0].result}</Number>
          </LargeWidgetValue>
        </React.Fragment>
    );
  }

  return (
    <BarChart
      showGroupValues
      data={data}
      title={widget.title}
      options={options}
      id={widget.id}
      total={data.reduce((total, datum) => total + datum.value, 0)}
      formulaDeletedQuestions={formulaDeletedQuestions}
    />
  );
}

export default BarChartWidget;
